import React from 'react';

import { STAFF_OPPORTUNITIES_LIST_QUERY_KEY } from '../../Organization/Opportunities/queryKeys';
import { OpportunitiesListPage } from '../../shared/opportunities';

export const StaffOpportunitiesList: React.FC = () => {
  return (
    <OpportunitiesListPage
      title="Opportunities"
      queryKeyBase={STAFF_OPPORTUNITIES_LIST_QUERY_KEY}
      displayTypePrefKey="StaffOpportunities"
      showOrganization={true}
      showOrganizationFilter={true}
      linkContext="staff"
      queueCategory="StaffOpportunityQueueNames"
    />
  );
};
